module.exports = __webpack_public_path__ + "static/media/Образец на пълномощно.75ff3356.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2021/Образец на пълномощно.pdf
// module id = 108
// module chunks = 0